<style lang="less" scoped>
tr, td {border: 1px solid #f5eeee;padding: 5px;border-bottom: 1px solid #f5eeee;}
.tr .td {float: left;}
.tr {width: 100%;height: 50px;}
.table {border-collapse: collapse;width: 100%;}
.select1 .el-input__inner {width: 150px;}
.ziduanKey .el-input__inner {width: 340px;}
.level .el-input__inner {width: 150px;}
.sort .el-input__inner {width: 150px;}
.date-picker.el-input {width: 200px;}
.count .el-input__inner {width: 50px;}
.el-checkbox {margin-right: 0px;}
.el-checkbox__inner {border-radius: 50%;}
.btnbox {width: 100%;text-align: left;border-bottom: 1px solid #e7e7eb;height: 60px;margin-bottom: 40px;}
.btnbox .elbtn {margin-top: 10px;margin-left: 15px;}
.recycling_box .delete {margin-left: 40px;}
.btnbox .level {margin-left: 10px;}
.el-form-item {float: left;margin-bottom: 0px;}
.el-pagination {text-align: center;}
.el-form table {width: 100%;}
.tr1 td .el-form-item /deep/.el-form-item__content {margin-left: 10px;}
.tr2 td .el-form-item /deep/.el-form-item__content {margin-left: 10px;}
.select1 /deep/ .el-input__inner {width: 150px;}
.ziduanKey /deep/ .el-input__inner {width: 340px;}
.level /deep/ .el-input__inner {width: 150px;}
.sort /deep/ .el-input__inner {width: 150px;}
.count /deep/ .el-input__inner {width: 50px;}
.pagination{margin-bottom: 40px;}
</style>

<template>
  <div class="second" id="second">
    <div class="dmkclb—_box second">
      <div class="el-tablebox">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          stripe
          border
          :cell-style="{ textAlign: 'center' }"
          :header-cell-style="{background: '#F5F5F5',color: '#606266',textAlign: 'center'}">
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column prop="title" label="标题"> </el-table-column>
          <el-table-column label="标题图片" width="145">>
              <template slot-scope="scope">
              <img :src="scope.row.thumb" width="100px" height="100px" class="head_pic"/>
            </template>
          </el-table-column>
          <el-table-column label="添加时间" width="155">
            <template slot-scope="scope">{{ (scope.row.addtime * 1000) | formatTime() }}</template>
          </el-table-column>
          <el-table-column prop="id" label="操作" width="180">
            <template slot-scope="scope">
              <el-button type="danger"  @click="deletefn(11, 74, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="block">
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange(this.form.count)"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="countSum">
      </el-pagination>
    </div>
  </div>
</template>

<script>
/**
 * 李旭
 * 首页数据管理列表页面
 */
import vuedraggable from 'vuedraggable'
import filters from '../method/filter'
export default {
  components: {vuedraggable},
  mixins: [filters],
  props: {
  },
  data()
  {
    return {
      tableData: [],
      lastData: [],
      countSum: null,
      currentPage: 1,
      pageSize: 20
    }
  },
  updated()
  {
    this.lastData = this.tableData.slice(-5)
    this.lastData.forEach((data, index) =>
    {
      let obj = {
        cmd: 'updateAtt',
        _major: 11,
        _minor: 74,
        retAtt: 1,
        id: data.id,
        orders: `${index}`
      }
      window.post.getPost(obj).then((ret) =>
      {
      })
    })
  },
  created()
  {
    this.getList()
  },
  methods: {
    getList()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 74, _exp: 'id > 0', orderby: 'orders ASC'}
      window.post.getPost(paras).then((ret) =>
      {
        if (ret.length > 0)
        {
          this.countSum = ret.length
          this.tableData = []
          ret.forEach((data, index) =>
          {
            this.tableData.push({ id: data.id, title: data.title, thumb: data.thumb, introduce: data.introduce, moduleName: '', addtime: data.addtime })
            let paras = {cmd: 'query', _major: 99, _minor: 4, _exp: `major = ${data.major} and minor = ${data.minor}`}
            window.post.getPost(paras).then((rets) =>
            {
              this.tableData[index].moduleName = rets[0].namec
            })
          })
        }
        else
        
          return false
      })
    },
    /**
     * 彻底删除--单
     * 获取下拉框列表
     * @param {String} major  //主类型
     * @param {String} minor  //子类型
     */
    deletefn(major, minor, row)
    {
      let that = this
      window.public.deletefn(major, minor, row, that)
    },
    //当选择项发生变化时会触发该事件
    handleSelectionChange(val)
    {
      console.log(val)
    },
    //每页条数
    handleSizeChange(val)
    {
      this.pageSize = val
    },
    //当前页数
    handleCurrentChange(val)
    {
      this.currentPage = val
      this.search()
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/assembly/FirInfoLB.vue